import React, { useEffect } from 'react';
import ParticlesBg from 'particles-bg';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const AttendanceHeader = (props) => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <header>
      <div style={{ backgroundColor: 'black' }} className='intro' data-aos='fade-up'>
        <ParticlesBg
          type='polygon'
          bg={{ zIndex: 0, position: 'absolute', top: 0 }}
        />
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div
                className='col-md-8 col-md-offset-2 intro-text'
                data-aos='fade-up'
                data-aos-delay='300'
              >
                <h2 style={{ color: 'white' }}>LiveID</h2>
                <div>
                  <h4 style={{ color: 'white' }}>
                    Biometric & AI-Powered Attendance — Accurate, Secure, and Built for Scale
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};